const trigger = document.querySelector('[data-menu-trigger]');
if (trigger) {
  trigger.addEventListener('click', () => {
    document.body.classList.toggle('menu_open');
  });
}

window.addEventListener('scroll', function () {
  if (window.scrollY > 100) {
    document.body.classList.add('body_flug');
  } else {
    document.body.classList.remove('body_flug');
  }
});